import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A towable light tower: a small trailer with a diesel genset box, stabiliser
// outriggers and a mast carrying four lamp heads on a crossbar. Site lighting
// you tow in and raise.
const TRAILER = "#3a3a3e";
const GENSET = "#ffcf3f";
const MAST = "#878e96";
const HOUSING = "#5f656b";
const LENS = "#fff0b0";
const WHEEL = "#222226";

export const lightTower = defineModel({
  id: "light-tower",
  batchId: "electric",
  name: "Light tower",
  tags: ["prop", "electric", "power", "lighting", "floodlight", "mobile"],
  summary: "A towable mast with four lamp heads over a genset trailer.",
  footprint: 0.5,
  parts(): Part[] {
    const parts: Part[] = [
      // Trailer chassis and tow hitch.
      { geometry: new THREE.BoxGeometry(0.7, 0.08, 0.44), color: TRAILER, position: [0, 0.16, 0] },
      { geometry: new THREE.BoxGeometry(0.3, 0.04, 0.04), color: TRAILER, position: [0.46, 0.16, 0] },
      { geometry: new THREE.CylinderGeometry(0.03, 0.03, 0.05, 8), color: "#5a5a5e", position: [0.62, 0.16, 0] },
      // Wheels.
      { geometry: new THREE.CylinderGeometry(0.1, 0.1, 0.06, 12), color: WHEEL, position: [-0.1, 0.1, 0.24], rotation: [Math.PI / 2, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.1, 0.1, 0.06, 12), color: WHEEL, position: [-0.1, 0.1, -0.24], rotation: [Math.PI / 2, 0, 0] },
      // Outrigger stabilisers.
      { geometry: new THREE.BoxGeometry(0.04, 0.04, 0.3), color: MAST, position: [-0.3, 0.12, 0.28] },
      { geometry: new THREE.BoxGeometry(0.04, 0.04, 0.3), color: MAST, position: [-0.3, 0.12, -0.28] },
      // Genset box on the trailer.
      { geometry: new THREE.BoxGeometry(0.44, 0.26, 0.36), color: GENSET, position: [-0.12, 0.33, 0] },
      { geometry: new THREE.BoxGeometry(0.3, 0.012, 0.02), color: "#caa033", position: [-0.12, 0.33, 0.185] },
      { geometry: new THREE.BoxGeometry(0.3, 0.012, 0.02), color: "#caa033", position: [-0.12, 0.28, 0.185] },
      // Telescoping mast.
      { geometry: new THREE.CylinderGeometry(0.05, 0.06, 0.5, 8), color: HOUSING, position: [-0.12, 0.6, 0] },
      { geometry: new THREE.CylinderGeometry(0.035, 0.04, 1.0, 8), color: MAST, position: [-0.12, 1.2, 0] },
      // Crossbar with four lamp heads.
      { geometry: new THREE.BoxGeometry(0.8, 0.05, 0.05), color: HOUSING, position: [-0.12, 1.66, 0] },
    ];
    for (const x of [-0.42, -0.22, -0.02, 0.18]) {
      parts.push({ geometry: new THREE.BoxGeometry(0.16, 0.12, 0.08), color: HOUSING, position: [x, 1.66, 0.1], rotation: [0.4, 0, 0] });
      parts.push({ geometry: new THREE.BoxGeometry(0.13, 0.09, 0.02), color: LENS, position: [x, 1.63, 0.15], rotation: [0.4, 0, 0] });
    }
    return parts;
  },
  animations: [],
});
